


















































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import AllConfigurationImages from "@/components/app/images/administration/all-configuration-images.vue";
import UploadingImageToServer from "@/components/app/images/uploading-image-to-server.vue";
import StandartModal from "@/components/app/standart-modal.vue";

import { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";
import { deleteImages } from "@/api/delite/delite-element";
import { pics } from "@/config/host.config";

@Component({
  components: {
    StandartModal,
    AllConfigurationImages,
    UploadingImageToServer,
  },
})
export default class LogoConfig extends Vue {
  @Prop({ type: String, default: "" }) image!: string;
  @Prop({ type: String, default: "" }) folder!: string;

  images: Array<string> = [];
  logo = this.image;

  @Watch("image")
  onImageChange(newVal: string): void {
    this.logo = newVal;
  }

  isOk(): void {
    this.$emit("changeLogo", this.logo);
  }

  deleteLogoImage(id: string): void {
    deleteImages(id, this.folder).then(() => {
      this.images.splice(this.images.indexOf(id), 1);
    });
  }

  async getImages(path: string): Promise<Array<string>> {
    const uri = pics.download;
    const config: AxiosRequestConfig = {
      params: { path },
    };
    return new Promise<Array<string>>((res, rej) => {
      this.$axios
        .get(uri, config)
        .then((imgs: AxiosResponse<Array<string>>) => {
          if (imgs.status === 200) res(imgs.data);
        })
        .catch((e: AxiosError) => {
          rej(e);
        });
    });
  }

  createImageList(): void {
    this.getImages(this.folder).then((imgs: Array<string> | string) => {
      if (imgs != "Папка не найдена") this.images = imgs as Array<string>;
    });
  }

  mounted(): void {
    this.createImageList();
  }
}
